import React from 'react'

import '../../utils/stringUtils'
import { Link } from "react-router"

const HomePage = () => (
	<div>
		<ul>
			<li><Link className="heading__infos--link" to={'/artist/36819'}>Artist</Link></li>
			<li><Link className="heading__infos--link" to={'/album/0886443927087'}>Album</Link></li>
			<li><Link className="heading__infos--link" to={'/track/9140031'}>Track</Link></li>
			<li><Link className="heading__infos--link" to={'/playlist/968239'}>Playlist</Link></li>
			<li><Link className="heading__infos--link" to={'/focus/123945'}>Focus</Link></li>
			<li><Link className="heading__infos--link" to={'/article/186402'}>Article</Link></li>
			<li><Link className="heading__infos--link" to={'/story/GCSVSTEYFZNLNCOQWAQIN2QIT4'}>Story</Link></li>
		</ul>
	</div>
)

export default HomePage



// WEBPACK FOOTER //
// ./src/pages/home/HomePage.jsx